export default {
  entities: {},
  getOutageBannerDetails: {
    hasFetched: false,
    isLoading: true,
    error: {}
  }
};
